module.exports = __webpack_public_path__ + "img/check.80a5404d.svg";